// extracted by mini-css-extract-plugin
module.exports = {"player-wrapper":"VideoPlayer_player-wrapper__YR9ot","react-player":"VideoPlayer_react-player__O0DM2"};